import { CustomDateZodSchema } from '#shared/date.model.js';
import { z } from 'zod';
import { NielsenPeriodStrSchema } from './nielsen.type.js';
export const NielsenIntervalSchema = z.object({
    start: NielsenPeriodStrSchema,
    end: NielsenPeriodStrSchema
});
export const ComparisonPeriodSchema = z.object({
    comparisonMode: z.enum(['previousYear', 'custom']),
    periodInterval: z
        .union([
        z.object({
            start: CustomDateZodSchema,
            end: CustomDateZodSchema
        }),
        NielsenIntervalSchema
    ])
        .optional()
});
export const isNielsenPeriod = (period) => {
    return period.period === 'nielsen';
};
export const isNielsenInterval = (interval) => {
    return typeof interval.start === 'string' && typeof interval.end === 'string';
};
export var DetentionPeriodValueType;
(function (DetentionPeriodValueType) {
    DetentionPeriodValueType["7Days"] = "7";
    DetentionPeriodValueType["14Days"] = "14";
    DetentionPeriodValueType["30Days"] = "30";
    DetentionPeriodValueType["60Days"] = "60";
})(DetentionPeriodValueType || (DetentionPeriodValueType = {}));
//# sourceMappingURL=period.type.js.map